"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _common = require("@insided/shared/utils/common");

var _MovedLink = _interopRequireDefault(require("@insided/deprecated-control/menu/MovedLink"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SidebarDetailsMenu = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SidebarDetailsMenu, _Component);

  var _super = _createSuper(SidebarDetailsMenu);

  function SidebarDetailsMenu() {
    var _this;

    (0, _classCallCheck2.default)(this, SidebarDetailsMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "arrowElement", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subMenuElement", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "timer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onArrowHoverLeave", function () {
      var _this$subMenuElement;

      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          setOverlay = _this$props.setOverlay;
      var isSubMenuHover = (_this$subMenuElement = _this.subMenuElement) === null || _this$subMenuElement === void 0 ? void 0 : _this$subMenuElement.matches(':hover');

      if (isOpen || !isSubMenuHover) {
        return;
      }

      _this.timer = window.setTimeout(function () {
        setOverlay(true);
      }, 500);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSubmenuHover", function () {
      var _this$arrowElement;

      var _this$props2 = _this.props,
          isOpen = _this$props2.isOpen,
          setOverlay = _this$props2.setOverlay;
      var isArrowHover = (_this$arrowElement = _this.arrowElement) === null || _this$arrowElement === void 0 ? void 0 : _this$arrowElement.matches(':hover');

      if (isOpen || isArrowHover) {
        return;
      }

      _this.timer = window.setTimeout(function () {
        setOverlay(true);
      }, 500);
    });
    return _this;
  }

  (0, _createClass2.default)(SidebarDetailsMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          isOpen = _this$props3.isOpen,
          sidebar = _this$props3.sidebar,
          isOverlay = _this$props3.isOverlay,
          setOverlay = _this$props3.setOverlay,
          onArrowClick = _this$props3.onArrowClick,
          onSidebarClose = _this$props3.onSidebarClose,
          spamCount = _this$props3.spamCount,
          customFilters = _this$props3.customFilters,
          customViews = _this$props3.customViews;

      if (this.props.sidebar.length === 0) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('control-side-menu__details', {
          collapsed: !isOpen,
          overlay: isOverlay
        }),
        ref: function ref(subMenu) {
          _this2.subMenuElement = subMenu;
        },
        onMouseEnter: function onMouseEnter() {
          return _this2.onSubmenuHover();
        },
        onMouseLeave: function onMouseLeave() {
          if (_this2.timer) {
            window.clearTimeout(_this2.timer);
          }

          if (!isOpen) {
            setOverlay(false, function () {
              return onSidebarClose();
            });
          }
        }
      }, sidebar.map(function (item) {
        return (0, _preact.h)("div", {
          key: item.name,
          className: "control-side-menu__items-wrapper"
        }, (0, _preact.h)("div", {
          className: "control-side-menu__details-heading"
        }, item.label), Array.isArray(item.links) ? (0, _preact.h)(ItemList, {
          item: item
        }) : (0, _preact.h)("div", null, (0, _preact.h)(GroupedItemList, {
          item: item,
          spamCount: spamCount
        }), item.name === 'moderation' && (customFilters.length > 0 || customViews.length > 0) && (0, _preact.h)(CustomFiltersList, {
          customFilters: customFilters,
          customViews: customViews
        })));
      }), (0, _preact.h)("div", {
        className: "control-side-menu__details-arrow",
        ref: function ref(arrow) {
          _this2.arrowElement = arrow;
        },
        onClick: onArrowClick,
        onMouseLeave: function onMouseLeave() {
          return _this2.onArrowHoverLeave();
        }
      }, (0, _preact.h)(_assets.default, {
        icon: "arrowRoundedLeft"
      })));
    }
  }]);
  return SidebarDetailsMenu;
}(_preact.Component);

var _default = SidebarDetailsMenu;
exports.default = _default;

var ItemList = function ItemList(_ref) {
  var item = _ref.item;
  return (0, _preact.h)("ul", null, item.links.map(renderLink({
    isCustomFilter: false
  })));
};

var GroupedItemList = function GroupedItemList(_ref2) {
  var item = _ref2.item,
      _ref2$spamCount = _ref2.spamCount,
      spamCount = _ref2$spamCount === void 0 ? null : _ref2$spamCount;
  return (0, _preact.h)("div", null, Object.entries(item.links).map(function (_ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
        groupName = _ref4[0],
        subLinks = _ref4[1];

    // Check if this is from AnalyticsSidebarItemProvider
    var isFromAnalytics = item.name === 'analytics' && subLinks.some(function (link) {
      var _link$route;

      return (_link$route = link.route) === null || _link$route === void 0 ? void 0 : _link$route.includes('/analyticsV2/');
    });
    return (0, _preact.h)("div", {
      key: groupName
    }, (0, _preact.h)("div", {
      className: "control-side-menu__details-sub-heading"
    }, groupName), (0, _preact.h)("ul", null, subLinks.map(renderLink({
      isCustomFilter: false,
      spamCount: spamCount,
      isFromAnalytics: isFromAnalytics
    }))));
  }));
};

var CustomFiltersList = function CustomFiltersList(_ref5) {
  var customFilters = _ref5.customFilters,
      customViews = _ref5.customViews;

  if (_common.common.isModuleActive('moderationOverviewBetaDefault')) {
    return (0, _preact.h)("div", null, (0, _preact.h)("div", {
      className: "control-side-menu__details-sub-heading"
    }, "custom views"), (0, _preact.h)("ul", null, customViews.length > 0 && customViews.map(renderLink({
      isCustomFilter: true
    })), customFilters.length > 0 && customFilters.map(renderLink({
      isCustomFilter: true,
      isDeprecated: true
    }))));
  }

  return (0, _preact.h)("div", null, customViews.length > 0 ? (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "control-side-menu__details-sub-heading"
  }, "custom views"), (0, _preact.h)("ul", null, customViews.map(renderLink({
    isCustomFilter: true
  })))) : null, customFilters.length > 0 ? (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "control-side-menu__details-sub-heading"
  }, "custom filters"), (0, _preact.h)("ul", null, customFilters.map(renderLink({
    isCustomFilter: true
  })))) : null);
};

var movedLinks = {
  'redirect/event/overview': {
    message: 'We have moved the Event page to the Platform section, and will remove it from this menu in the future',
    redirectLink: '/event/overview'
  }
};
var analyticsElementNameMap = {
  'Product Feedback': 'product-feedback-dashboard',
  Engagement: 'engagement-dashboard',
  'Q&A': 'q-and-a-dashboard',
  Audience: 'audience-dashboard',
  'Self-service': 'self-service-dashboard',
  Content: 'content-dashboard',
  User: 'user-dashboard',
  'AI Moderation': 'ai-moderation-dashboard',
  'Search Analytics': 'search-analytics-dashboard',
  'New Dashboards': 'new-ha-dashboards'
};

var trackAnalyticsEvent = function trackAnalyticsEvent(linkLabel) {
  var dashboardName = analyticsElementNameMap[linkLabel] || linkLabel;

  _publish.default.trackEvent('userevent', {
    boundedContext: 'Analytics',
    entity: 'menu',
    trackType: 'click',
    elementName: dashboardName,
    eventDetail: "analytics.menu.".concat(dashboardName, "Clicked"),
    event_source: 'control'
  });
};

var renderLink = function renderLink(_ref6) {
  var isCustomFilter = _ref6.isCustomFilter,
      _ref6$isDeprecated = _ref6.isDeprecated,
      isDeprecated = _ref6$isDeprecated === void 0 ? false : _ref6$isDeprecated,
      _ref6$spamCount = _ref6.spamCount,
      spamCount = _ref6$spamCount === void 0 ? null : _ref6$spamCount,
      _ref6$isFromAnalytics = _ref6.isFromAnalytics,
      isFromAnalytics = _ref6$isFromAnalytics === void 0 ? false : _ref6$isFromAnalytics;
  return function (link) {
    var _link$route$includes, _link$route2, _link$route3;

    var isActive = (0, _utils.isActiveLink)(link);
    var isSpam = link.label.toLowerCase() === 'spam';
    var normalizedLabel = link.label.toLowerCase().replace(/ /g, '_');
    var isHorizonAnalyticsEnabled = (_link$route$includes = link === null || link === void 0 ? void 0 : (_link$route2 = link.route) === null || _link$route2 === void 0 ? void 0 : _link$route2.includes('ha-dashboard')) !== null && _link$route$includes !== void 0 ? _link$route$includes : false;
    var isAnalyticsLink = isFromAnalytics && (((_link$route3 = link.route) === null || _link$route3 === void 0 ? void 0 : _link$route3.includes('/analyticsV2/')) || isHorizonAnalyticsEnabled);

    if (movedLinks[link.route]) {
      var movedLink = movedLinks[link.route];
      return (0, _preact.h)(_MovedLink.default, {
        label: link.label,
        normalizedLabel: normalizedLabel,
        message: movedLink.message,
        redirectLink: movedLink.redirectLink
      });
    }

    if (isHorizonAnalyticsEnabled) {
      return (0, _preact.h)("li", {
        className: (0, _classnames.default)("navigation-menu__item--".concat(normalizedLabel), {
          custom: isCustomFilter,
          'qa-custom': isCustomFilter
        })
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('sidebar-item-ha', {
          active: isActive
        }),
        style: {
          display: 'flex',
          alignItems: 'center',
          height: '36px',
          cursor: 'pointer'
        }
      }, (0, _preact.h)("div", {
        className: "sidebar-item-title",
        style: {
          display: 'flex',
          width: '135px',
          height: '100%',
          position: 'relative'
        }
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(link.route),
        style: {
          background: 'none',
          color: isActive ? '#0369e9' : 'inherit'
        },
        onClick: function onClick() {
          return isAnalyticsLink && trackAnalyticsEvent(link.label);
        }
      }, link.label, isDeprecated && (0, _preact.h)(_assets.default, {
        customClass: "icon-warning",
        color: "#9599A2",
        icon: "warning",
        width: 20,
        height: 20
      }), isSpam && spamCount !== null && (0, _preact.h)("span", null, "(", spamCount, ")"))), link.isBeta && (0, _preact.h)("span", {
        className: "beta-label-secondary"
      }, "BETA")));
    }

    return (0, _preact.h)("li", {
      className: (0, _classnames.default)("navigation-menu__item--".concat(normalizedLabel), {
        custom: isCustomFilter,
        'qa-custom': isCustomFilter
      })
    }, (0, _preact.h)("a", {
      className: isActive ? 'active' : undefined,
      href: (0, _absoluteUrlRuntime.resolveUrl)(link.route),
      onClick: function onClick() {
        return isAnalyticsLink && trackAnalyticsEvent(link.label);
      }
    }, link.label, isDeprecated && (0, _preact.h)(_assets.default, {
      customClass: "icon-warning",
      color: "#9599A2",
      icon: "warning",
      width: 20,
      height: 20
    }), isSpam && spamCount !== null && (0, _preact.h)("span", null, "(", spamCount, ")"), link.isBeta && (0, _preact.h)("span", {
      className: "beta-label-secondary"
    }, "BETA")));
  };
};